var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagMac(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 1.03088e-06 27.165 0 17.5C0 7.83502 7.83502 2.06176e-06 17.5 0ZM15.5469 14.8232H9.2334L14.3428 18.5303L12.3906 24.5381L17.499 20.8242L22.6084 24.5381L20.6562 18.5303L25.7656 14.8232H19.4512L17.499 8.81641L15.5469 14.8232ZM16.5029 20.1006L14.6318 21.4561L15.3447 19.2607L16.5029 20.1006ZM20.373 21.4561L18.502 20.1006L19.6602 19.2607L20.373 21.4561ZM18.5938 15.999L19.2715 18.085L17.499 19.3701L15.7266 18.085L16.3984 15.999H18.5938ZM15.165 15.999L14.7246 17.3545L12.8594 15.999H15.165ZM22.1396 15.999L20.2744 17.3545L19.834 15.999H22.1396ZM18.2178 14.8232H16.7871L17.5049 12.6221L18.2178 14.8232Z",
    fill: "url(#paint0_linear_13090_62969)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3914 24.5377L14.3436 18.5305L9.23438 14.8232H15.5485L17.5007 8.81604L19.4528 14.8232H25.767L20.6577 18.5305L22.6099 24.5377L17.5007 20.8245L12.3914 24.5377ZM18.5028 20.1004L20.3739 21.4559L19.6614 19.2604L18.5028 20.1004ZM15.3458 19.2604L14.6332 21.4559L16.5043 20.1004L15.3458 19.2604ZM15.7281 18.0845L17.5007 19.3705L19.2733 18.0845L18.5955 15.9991H16.4L15.7281 18.0845ZM12.8607 15.9991L14.7259 17.3546L15.1662 15.9991H12.8607ZM20.2754 17.3546L22.1407 15.9991H19.8352L20.2754 17.3546ZM16.7882 14.8232H18.219L17.5065 12.6219L16.7882 14.8232Z",
    fill: "#00833E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13090_62969",
    x1: 0.00156405,
    y1: 17.4983,
    x2: 34.9977,
    y2: 17.4983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE1A17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE1A17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMac);
export default __webpack_public_path__ + "static/media/flagMAC.ca70a722dfcf338c87e9bb56674042eb.svg";
export { ForwardRef as ReactComponent };